import { render } from "./VsudInput.vue?vue&type=template&id=636b79f2"
import script from "./VsudInput.vue?vue&type=script&lang=js"
export * from "./VsudInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__